import styles from "./ArticleInfo.module.scss";
import Link from "next/link";
import { ArticleDate } from "./ArticleDate";
import { readtime } from "@/helpers/blog/readtime";
import { parseEditorContentToString } from "@/helpers/common";
import { useArticleSinglePageContext } from "@/helpers/contexts/ArticleSinglePageContext";
import { StrapiArticleSectionDynamicZoneItem } from "@/types/strapi/components/article/section";
import { ShareButton } from "@/components/UI/Buttons/ShareButton";
import { WrappedIcon } from "@/components/UI/WrappedIcon";
import Image from "next/image";

type ArticleInfoProps = {
  showShareBtn?: boolean;
};

export const TArticleInfo = ({ showShareBtn = true }: ArticleInfoProps) => {
  const data = useArticleSinglePageContext();
  if (!data) return null;
  // @ts-ignore
  const { publishedAt, updatedAt, categories, content, textAfterHeading } = data.article;

  const contentString =
    content
      .map(({ __component, ...rest }) => {
        if (__component !== "article.section") return;
        return parseEditorContentToString(JSON.parse((rest as StrapiArticleSectionDynamicZoneItem).content));
      })
      .filter((item) => !!item)
      .join(" ") +
    " " +
    parseEditorContentToString(textAfterHeading);

  const readingTime = readtime(contentString);

  const author = categories?.data?.[0]?.attributes?.author?.data?.attributes;

  const authorImage = author?.avatar?.data?.attributes;

  return (
    <div className={styles.main}>
      {author && (
        <Link href={`/authors/${author.slug}`} className={styles.author} prefetch={false}>
          {authorImage && (
            <Image
              src={authorImage.url}
              alt={authorImage.alternativeText || ""}
              width={54}
              height={54}
              className={styles.authorPhoto}
              quality={100}
            />
          )}
          <div className={styles.authorName}>{author.fullName}</div>
        </Link>
      )}
      {updatedAt || publishedAt ? (
        <div className={styles.date}>
          <WrappedIcon icon="updated" />
          <ArticleDate date={updatedAt || publishedAt} />
        </div>
      ) : null}
      <div className={styles.dot} />
      <div className={styles.readTime}>
        <WrappedIcon icon="hourglass-done" />
        {readingTime} min read
      </div>

      {showShareBtn && <ShareButton className={styles.share} />}
    </div>
  );
};
